import { Injectable } from '@angular/core';
import { timeout } from 'rxjs/operators';

import { DbService } from '../db.service';
import { SessionService } from '../session.service';

/**
 * Consulta única, na inicialização da aplicação (login, F5, novo carregamento), dos relatórios de
 * Solicitações Especiais do usuário autenticado. Substitui a lista que estava no sessionStorage
 * (gravada no login) pela lista corrente do banco, sem novo login e sem renovar a sessão.
 * Não há atualização periódica.
 */
@Injectable()
export class RelatoriosService {
    private readonly TIMEOUT_MS = 8000;
    private iniciado: boolean = false;

    constructor(
        private dbService: DbService,
        private sessionService: SessionService
    ) { }

    carregar(): void {
        if (this.iniciado) {
            return;
        }
        this.iniciado = true;

        this.sessionService.fnGetSessao();
        const hash = this.sessionService.usuario.hash;

        if (!hash) {
            return;
        }

        this.dbService.getSilencioso('PedidoRelatorio/Meus')
            .pipe(timeout(this.TIMEOUT_MS))
            .subscribe(result => {
                if (this.sessionService.usuario.hash === hash && result) {
                    // Sessão inválida/expirada: a lista antiga não pode seguir valendo como autorizada
                    const lista = result.autenticado === true ? (result.lstRelatorios || []) : [];
                    this.sessionService.usuario.lstRelatorios = lista;
                    this.sessionService.usuario.nrRelatorios = lista.length;
                    this.sessionService.fnSetSessao();
                }
            }, error => {
                // Falha de comunicação: mantém o que já havia, sem logout
                console.error('Falha ao atualizar relatórios de Solicitações Especiais:', error);
            });
    }
}
